import { useState } from 'react';
import { useQuiz } from '../context/QuizContext';
import { BookOpen } from 'lucide-react';
import type { Pergunta } from '../types/quiz.types';
import { GameShell } from '../components/layout/GameShell';

const PERGUNTAS_TUTORIAIS: Pergunta[] = [
  { id: 'tut1', fase: 0, pergunta: 'O que o Axé dos Deuses faz?', opcoes: ['Pula a pergunta.', 'Dá 1 nível extra.', 'Elimina 2 alternativas incorretas.', 'Mostra estatísticas da comunidade.'], correta_index: 2, feedback_estudo: '', dificuldade_tecnica: 1, status: 'ativo' },
  { id: 'tut2', fase: 0, pergunta: 'O que o Caminho de Mandela faz?', opcoes: ['Dá dica Grió.', 'Duplica as moedas se você acertar.', 'Pula a pergunta sem perder progresso.', 'Revive você se errar a questão.'], correta_index: 2, feedback_estudo: '', dificuldade_tecnica: 1, status: 'ativo' },
  { id: 'tut3', fase: 0, pergunta: 'Quando o poder Ubuntu deve ser usado?', opcoes: ['Quando você precisa da sabedoria da comunidade para escolher a opção certa.', 'Quando quer destruir as vidas do adversário humano.', 'Para pular o cronômetro.', 'Nenhuma das anteriores.'], correta_index: 0, feedback_estudo: '', dificuldade_tecnica: 1, status: 'ativo' }
];

export function TutorialScreen() {
  const { dispatch } = useQuiz();
  const [indicePergunta, setIndicePergunta] = useState(0);
  const perguntas = PERGUNTAS_TUTORIAIS;
  const pergunta = perguntas[indicePergunta];

  const handleResponder = (index: number) => {
    if (index === pergunta.correta_index) {
      if (indicePergunta + 1 >= perguntas.length) {
        dispatch({ type: 'FINISH_TUTORIAL' });
      } else {
        setIndicePergunta((i) => i + 1);
      }
    }
  };

  if (!pergunta) return null;

  return (
    <GameShell maxWidth="xl" maxHeightCeiling="max-h-[min(100%,36rem)]" center>
      <div className="flex-1 min-h-0 flex flex-col items-center justify-between text-center my-auto">
        <div className="w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mb-2 shrink-0">
          <BookOpen className="text-amber-500 w-8 h-8" />
        </div>
        <h1 className="text-fluid-title font-bold text-amber-400 mb-1">Terreiro do Conhecimento</h1>
        <p className="text-slate-400 text-fluid-sm mb-3">O Griô te guia. Estas perguntas não consomem vidas nem geram moedas.</p>

        <p className="text-slate-300 text-fluid-sm mb-1 font-cyber">Pergunta {indicePergunta + 1} de 3</p>
        <h2 className="text-fluid-subtitle font-bold text-white mb-4 text-center">{pergunta.pergunta}</h2>

        <div className="grid gap-2 w-full shrink-0">
          {pergunta.opcoes.map((opcao, idx) => (
            <button
              key={idx}
              onClick={() => handleResponder(idx)}
              className="btn-cyber w-full text-left p-3 rounded-xl border font-medium text-fluid-body transition
                border-slate-700 bg-slate-800/70 text-slate-100
                hover:bg-amber-400 hover:text-slate-900 hover:border-amber-400"
            >
              {opcao}
            </button>
          ))}
        </div>

        <button
          onClick={() => dispatch({ type: 'NAVIGATE', payload: 'MENU' })}
          className="mt-4 text-slate-500 hover:text-slate-300 text-fluid-sm underline font-cyber uppercase tracking-wider"
        >
          Pular Tutorial
        </button>
      </div>
    </GameShell>
  );
}
